module.exports = __webpack_public_path__ + "img/loading.7b078c21.png";